import { CompassMark } from "@/components/compass-intro";

/**
 * Calm, on-brand loading visual that reuses the `CompassIntro` look — the gold
 * compass rose on the dark backdrop — but in a gentle, indefinite spin instead
 * of the one-time intro choreography. Use this anywhere we need to communicate
 * "loading" without ever flashing the maintenance message:
 *
 *  - `fullscreen` covers the viewport while the initial auth check resolves and
 *    across the login → destination transition (App boot).
 *  - `inline` fills its container, used by the route-level Suspense fallback so
 *    page-to-page navigation feels consistent with the boot loader.
 */
export function CompassLoader({
  variant = "fullscreen",
  cover = false,
}: {
  variant?: "fullscreen" | "inline";
  /** Sit above the impersonation banner and every portal shell. */
  cover?: boolean;
}) {
  return (
    <div
      className={
        variant === "fullscreen"
          ? `compass-loader-overlay${cover ? " compass-loader-overlay-cover" : ""}`
          : "compass-loader-inline"
      }
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid="compass-loader"
    >
      <span className="sr-only">Loading…</span>
      <div className="compass-loader-inner">
        <CompassMark className="compass-loader-svg compass-loader-spin" />
      </div>
    </div>
  );
}
